import React, { Component } from 'react';
import Switch from '../Part_Sample/Switch';

export default class Command_RGB_Input extends Component {
	constructor(props) {
		super(props);

		let rgbw_hex = "#000000";
		if (this.props.action_details.rgbw != null) {
			let hex = this.props.action_details.rgbw.toString(16); //convert decimal to hexadecimal
			let str = "";
			//Convert into proper 8 hexadecimals - add the missing 0s
			for (let i = 0; i < 8 - hex.length; i++) {
				str = "0" + str;
			}
			hex = str + hex;
			rgbw_hex = "#" + hex.substring(0, hex.length - 2); // add # prefix and remove w parameter
		}

		this.state = {
			is_enabled: this.props.action_details.rgbw != null ? true : false,
			rgbw: this.props.action_details.rgbw != null ? this.props.action_details.rgbw : 0,
			rgbw_hex: rgbw_hex,
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		let is_enabled = false;
		if (nextProps.action_details.rgbw != null) is_enabled = true;
		if (is_enabled != nextState.is_enabled) {
			this.setState({
				is_enabled: is_enabled,
			})
		}

		let rgbw = nextProps.action_details.rgbw != null ? nextProps.action_details.rgbw : 0
		let rgbw_hex = "#000000";
		if (nextProps.action_details.rgbw != null) {
			let hex = nextProps.action_details.rgbw.toString(16); //convert decimal to hexadecimal
			let str = "";
			//Convert into proper 8 hexadecimals - add the missing 0s
			for (let i = 0; i < 8 - hex.length; i++) {
				str = "0" + str;
			}
			hex = str + hex;
			rgbw_hex = "#" + hex.substring(0, hex.length - 2); // remove w parameter
		}

		if (rgbw != nextState.rgbw) {
			this.setState({
				rgbw: rgbw,
				rgbw_hex: rgbw_hex
			})
		}
		return true;
	}

	handleToggleEnable = () => {
		let is_enabled = !this.state.is_enabled
		this.setState({ is_enabled: is_enabled })
		if (is_enabled) {
			this.props.handleChangeRGB(this.state.rgbw_hex);
		} else {
			this.props.handleChangeRGB(null);
		}
	}

	handleChangeRGB = (val) => {
		if (this.state.is_enabled) {
			let hex_code = val.substring(1); //remove # 
			let rgbw_code = parseInt(hex_code, 16); //Convert hex value to decimal value
			this.setState({
				rgbw_hex: val,
				rgbw: rgbw_code
			})

			this.props.handleChangeRGB(val);
		} else {
			window.app.showToast(this.props.receiver.getString('no_enabled'), 3000);
			return;
		}
	}

	render() {
		let style = {
			textAlign: 'left',
			width: this.props.width - 40,
			marginTop: 10,
			marginLeft: 10,
			background: 'white',
			padding: 10,
			borderRadius: 20,
		}

		return (
			<div style={style}>
				<div style={{ display: 'inline-block', verticalAlign: 'top' }}>
					<Switch style={{ display: 'inline-block', verticalAlign: 'top' }} is_enabled={this.state.is_enabled} handleToggleSwitch={this.handleToggleEnable} />
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', marginTop: 2, marginLeft: 5, width: this.props.width - 195 }}>
					<span>{this.props.receiver.getString('color')}</span>
				</div>
				<div style={{ display: 'inline-block', verticalAlign: 'top', width: 100, textAlign: 'end' }}>
					<input type="color" value={this.state.rgbw_hex} onChange={(event) => this.handleChangeRGB(event.target.value)}>
					</input>
				</div>
			</div>
		)
	}
}